import React, { useEffect, useState } from 'react';
import { getExpressParams } from '../../../service/api';
import InsightPageMain from '../../presentation/section/insight-page/InsightPageMain';

const InsightPage = (props) => {
  const [insightData, setInsightData] = useState({
    noticeID: null,
    onTop: null,
    owner: null,
  });

  useEffect(()=>{
    getExpressParams('/notice/noticeid', {
      noticeID: props.match.params.noticeID
    }, (response) => {
      
      response.data.noticeentity.forEach(item=>setInsightData(item))
    })
  }, [])
  
  return (
    <InsightPageMain insightData={insightData} />
  )
}

export default InsightPage;
